module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "eBook4242-2.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Title para-style-override-2",
    attrs: {
      "id": "toc_marker-3"
    }
  }, [_c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Other Titles by Jimmy Santiago Baca")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }, [_vm._v("Published by Grove Press")]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Memoir")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("A Place to Stand")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("The Importance of a Piece of Paper")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("A Glass of Water")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-4"
  }, [_vm._v("Poetry")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("Healing Earthquakes")])]), _vm._v(" "), _c('p', {
    staticClass: "poems"
  }, [_c('span', {
    staticClass: "char-style-override-5"
  }, [_vm._v("C-Train and Thirteen Mexicans")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69a5470c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBook42422.vue
// module id = 66
// module chunks = 0